export const inlineMenuSx = {
  alignItems: 'center',
  bgcolor: '#fff',
  border: '1px solid rgba(0, 0, 0, 0.16)',
  boxShadow: '0 3px 10px rgba(0, 0, 0, 0.18)',
  borderRadius: 1,
  display: 'flex',
  minHeight: 34,
  position: 'absolute',
  transform: 'translateY(-100%)',
  zIndex: 2000,
};

export const inlineMenuPopoutSx = {
  bgcolor: '#fff',
  border: '1px solid rgba(0, 0, 0, 0.16)',
  borderRadius: 1,
  boxShadow: '0 3px 10px rgba(0, 0, 0, 0.18)',
  left: 0,
  position: 'absolute',
  top: 40,
  zIndex: 1,
};

export const shapePanelSx = {
  ...inlineMenuPopoutSx,
  display: 'grid',
  gap: 1,
  p: 1.25,
  width: 235,
};

export const panelLabelSx = {
  fontSize: 13,
  fontWeight: 700,
  lineHeight: 1.2,
};
